import { HStack, Stack, useColorModeValue, VStack, Image, Heading } from '@chakra-ui/react'
import { RPSForm } from '../components'
import rpsSvg from '../assets/rps.svg'

const RockPaperScissors = () => {
  return (
    <VStack
      spacing={{ base: '30px' }}
      minH={{ base: '68vh', md: '80vh' }}
      wrap={'wrap'}
      align={'center'}
      justify={'center'}
    >
      <HStack minH={{ base: '68vh', md: '80vh' }} wrap={'wrap'} align={'center'} justify={'center'}>
        <Image src={rpsSvg} boxSize={{ base: '220px', md: 'sm' }}></Image>
        <Stack
          spacing={4}
          bg={useColorModeValue('white', 'gray.700')}
          rounded={'xl'}
          boxShadow={'lg'}
          p={{ base: '6', md: '8' }}
          my={{ base: '6', md: '12' }}
          maxW={{ base: '3xl', md: 'xl' }}
        >
          <Heading
            textAlign={'center'}
            fontSize={{ base: '2xl', md: '3xl' }}
            color={"brand.500"}
            mb={{ base: 0, md: 4 }}
          >
            Rock Paper Scissors ✊🤚✌️
          </Heading>
          <RPSForm />
        </Stack>
      </HStack>
    </VStack>
  )
}
export default RockPaperScissors
